module.exports = __webpack_public_path__ + "static/NHS_Logo-19c6138c0f0066b2684ce71851d56d99.png";